import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("button", {
    onClick: _cache[1] || (_cache[1] = $event => (_ctx.handleClick())),
    class: ["rounded-full w-16 shadow-inner focus:outline-none text-left border transition-all duration-100 ease-in-out", {
			'border-primary bg-primary bg-opacity-50 border-opacity-50': _ctx.value,
			'border-gray-200 bg-gray-200': !_ctx.value,
		}],
    style: {"height":"2.15rem"},
    type: "button"
  }, [
    _createVNode("span", {
      class: ["inline-block rounded-full bg-white w-8 h-8 transition duration-100 ease-in-out transform", {
				'translate-x-9/10': _ctx.value,
				'translate-x-0': !_ctx.value,
			}]
    }, null, 2)
  ], 2))
}